import { currencyOptions } from 'utils';

export const fetchCurrencyData = (currency: string) =>
  currencyOptions.find(
    (option) => option.code.toLowerCase() === currency.toLowerCase(),
  );
